// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".items[data-v-133179a8]{margin-top:39px;text-align:right}.item[data-v-133179a8]{display:inline-block;vertical-align:top;width:48px;height:48px;border-radius:50%;background:#575c69;line-height:46px;text-align:center;transition:.3s}.item+.item[data-v-133179a8]{margin-left:12px}.item[data-v-133179a8]:hover{background:#fff}.social-icon[data-v-133179a8]{fill:#292e3b}.item-steam[data-v-133179a8]{text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
